export const paths = {
  root: '/',
  contentType: {
    root: '/content-type',
    details: (id: string) => `/content-type/${id}`
  },
  content: {
    root: '/content',
    create: (id: string) => `/content/create/${id}`,
    edit: (typeId: string, id: string) => `/content/edit/${typeId}/${id}`
  },
  media: {
    root: '/media'
  },
  access: {
    root: '/access',
    tab: (tab: string) => `/access/${tab}`,
    edit: (group: string, id: string) => `/access/edit/${group}/${id}`
  },
  locales: {
    root: '/locales'
  },
  settings: {
    root: '/settings'
  },
  forms: {
    root: '/forms',
    create: '/forms/create',
    edit: (id: string) => `/forms/${id}`,
    editTab: (id: string, tab: string) => `/forms/${id}/${tab}`
  },
  contentTypes: {
    root: '/content-types',
    details: (id: string) => `/content-types/${id}`
  },
  newsletter: {
    root: '/newsletter',
    create: '/newsletter/create',
    edit: (id: string) => `/newsletter/${id}`
  }
}
